import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface UserRoles {
  isSuperAdmin: boolean;
  isAdmin: boolean;
  isManager: boolean;
  isInstructor: boolean;
}

const fetchUserRoles = async (): Promise<UserRoles | null> => {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;

  const [adminResult, managerResult, superAdminResult, instructorResult] = await Promise.all([
    supabase.rpc('has_role', { _user_id: user.id, _role: 'admin' }),
    supabase.rpc('has_role', { _user_id: user.id, _role: 'manager' }),
    supabase.rpc('has_role', { _user_id: user.id, _role: 'super_admin' }),
    supabase.rpc('has_role', { _user_id: user.id, _role: 'instructor' }),
  ]);

  return {
    isAdmin: Boolean(adminResult.data),
    isManager: Boolean(managerResult.data),
    isSuperAdmin: Boolean(superAdminResult.data),
    isInstructor: Boolean(instructorResult.data),
  };
};

export const useUserRole = () => {
  return useQuery({
    queryKey: ["user-roles"],
    queryFn: fetchUserRoles,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
};
